import AncillaryOfferUIModel from './ancillary-offer';
import BaggageAncillaryOfferUIModel from './baggage-ancillary-offer';
import UpgradeAncillaryOfferUIModel from './upgrade-ancillary-offer';
import ANCILLARY_OFFER_TYPES from '../../scripts/constants/ancillary-offer-types';

class AncillaryOfferCollectionUIModel {
  constructor({ _collection = [] }) {
    this._ancillaries = [];
    this._carryonOffer = [];
    for (let i = 0; i < _collection.length; i++) {
      let ancillary = null;
      if (_collection[i].ancillary && _collection[i].ancillary.type === 'UPG') {
        ancillary = new UpgradeAncillaryOfferUIModel(_collection[i]);
      } else if (_collection[i]._meta.class === ANCILLARY_OFFER_TYPES.ANCILLARY) {
        ancillary = new AncillaryOfferUIModel(_collection[i]);
      } else if (_collection[i]._meta.class === ANCILLARY_OFFER_TYPES.BAGGAGE_ANCILLARY) {
        ancillary = new BaggageAncillaryOfferUIModel(_collection[i]);
      }
      this._ancillaries.push(ancillary);
    }
  }

  getAllAncillaries() {
    return this._ancillaries;
  }

  getBaggageAncillaryOffer() {
    const baggageAncillaryList = this._ancillaries.filter(ancillaryOffer => {
      return ancillaryOffer && ancillaryOffer.offerClass === ANCILLARY_OFFER_TYPES.BAGGAGE_ANCILLARY;
    });

    return baggageAncillaryList ? baggageAncillaryList[0] : null;
  }

  getPriorityAncillaryOffer() {
    const ancillaryPriArray = this._ancillaries.filter(ancillaryOffer => {
      if (ancillaryOffer && ancillaryOffer.offerClass === ANCILLARY_OFFER_TYPES.ANCILLARY) {
        return ancillaryOffer.ancillary.type === 'PRI';
      }
    });

    return ancillaryPriArray ? ancillaryPriArray[0] : null;
  }

  getVuelaVerdeAncillaryOffer() {
    const ancillaryVuelaVerdeArray = this._ancillaries.filter(ancillaryOffer => {
      if (ancillaryOffer?.offerClass === ANCILLARY_OFFER_TYPES.ANCILLARY) {
        return ancillaryOffer?.ancillary?.type === '09T';
      }
    });

    return ancillaryVuelaVerdeArray ? ancillaryVuelaVerdeArray[0] : null;
  }

  getBaggageLightAncillaryOffer() {
    const baggageAncillaryList = this._ancillaries.filter(ancillaryOffer => {
      return ancillaryOffer.offerClass === ANCILLARY_OFFER_TYPES.BAGGAGE_LIGHT_ANCILLARY;
    });

    return baggageAncillaryList ? baggageAncillaryList[0] : null;
  }

  /**
   * @return {Array}
   */
  getNonBaggageAncillaries() {
    return this._ancillaries.filter(ancillaryOffer => {
      return ancillaryOffer.offerClass === ANCILLARY_OFFER_TYPES.ANCILLARY;
    });
  }

  /**
   * @return {Object}
   */
  getExtraBaggageAncillaries() {
    const baggageAncillaryList = this._ancillaries.filter(ancillaryOffer => {
      return ancillaryOffer.offerClass === ANCILLARY_OFFER_TYPES.BAGGAGE_ANCILLARY;
    });

    return baggageAncillaryList.length ?
      baggageAncillaryList[0].extraBags.getAllAncillaries() : {};
  }

  getNumberOfAncillaries() {
    return this._ancillaries.length;
  }

  hasAncillariesInCollection() {
    return this.getNumberOfAncillaries() > 0;
  }

  getCarryonOffer() {
    const carryOnList = this._ancillaries.filter(ancillaryOffer => {
      return ancillaryOffer?.offerClass === ANCILLARY_OFFER_TYPES.CARRY_ON_OFFER;
    });

    return carryOnList.length ?
      carryOnList?.[0]?.carryOn?.getAllAncillaries() : [];
  }

  get0CZCarryOn() {
    const ancillaryOffer = this.getCarryonOffer();
    return ancillaryOffer.find(offer => {
      return offer.type === '0CZ';
    });
  }
}

export default AncillaryOfferCollectionUIModel;
